import React from "react";

const NoPermission = ({ message }) => {
  return (
    <div
      style={{
        padding: "2rem",
        textAlign: "center",
        color: "#b91c1c",
        background: "#fef2f2",
        border: "1px solid #fca5a5",
        borderRadius: "8px",
        margin: "2rem auto",
        maxWidth: "500px",
        fontSize: "1.2rem",
      }}
    >
      <strong>
        🚫{" "}
        {message ||
          "You do not have permission to view this section or perform this action."}
      </strong>
    </div>
  );
};

export default NoPermission;
